<label #labelWrapper class="form-field" [ngClass]="{ 'form-field-entered': value }">
  <ng-content></ng-content>
  <span *ngIf="label" class="form-field-label" [ngClass]="{ 'form-field-label_shrinked': isShrinked || value }">
    {{ label }}
  </span>
  <span class="form-field-required"></span>
</label>
